
export function stripeElementsOptions(clientSecret, locale) {
  if (!clientSecret || !locale) {
    console.error("Missing mandatory fields for Stripe <Elements />");
    return {}
  }

  return {
    // Mandatory fields
    clientSecret: clientSecret,
    locale: locale,
    // Customisation
    loader: "always",
    appearance: {
      theme: 'stripe',
      variables: {
        fontFamily: '"AbelPro", Arial, sans-serif',
        fontSizeBase: "18px",
        borderRadius: '4px',
        colorBackground: '#fff',
        colorPrimary: "#005083", // --primary-blue-700
        colorText: "#141414", // --grey-900
        colorDanger: "#d42b2b", // --accent-red-600
        colorTextPlaceholder: "#c2c2c2", // --grey-300
        focusOutline: "none",
        focusBoxShadow: "#e7eef5", // --primary-blue-200
      },
      rules: {
        '.Block': {
          boxShadow: 'none',
        },
        '.Label': {
          fontSize: "14px",
          lineHeight: "18px",
          marginBottom: "4px",
        },
        '.Input': {
          outline: "none",
          boxShadow: 'none',
          border: "1px solid #999", // var(--grey-400)
        },
        '.Input:focus': {
          borderColor: "#005083", // --primary-blue-700
          boxShadow: "0 0 0 5px #e7eef5", // --primary-blue-200
          color: "#005083", // --primary-blue-700
        },
        '.Input--invalid': {
          borderColor: "#d42b2b", // --accent-red-600
          boxShadow: "0 0 0 5px rgba(255, 233, 230, 0.7)",
        },
        '.Input--invalid:focus': {
          boxShadow: "0 0 0 5px #e7eef5", // --primary-blue-200
        },
        '.Error': {
          // Error text below inputs
          marginTop: "8px",
          fontSize: "14px",
        },
      },
    },
  }
}